// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.maintenance.tasks.RentalManagerUserMaintenanceTaskWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { RentalManagerUserMaintenanceTaskListDto } from '../..';

interface ListParams {
  includeComplete?: boolean;
  includeInProgress?: boolean;
  includeNotStarted?: boolean;
  includeWontComplete?: boolean;
}

export const RentalManagerUserMaintenanceTaskWebApiHandler_list_Path = '/api/web/v1/users/maintenance/tasks/list';

/**
 * Get maintenance task list for user
 */
export const RentalManagerUserMaintenanceTaskWebApiHandler_list = (
  getParams: ListParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ListParams, never, RentalManagerUserMaintenanceTaskListDto>({
    getParams: getParams,
    endpoint: RentalManagerUserMaintenanceTaskWebApiHandler_list_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
